module.exports = __webpack_public_path__ + "static/img/logo2.d39cf38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2.png
// module id = /eIm
// module chunks = 5